import { RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { INormalisedResult } from '../interfaces/interfaces';
import { RestRequest } from '../services/api/request';
import { ApiRequestOptions } from '../services/api/request-options';
import { VASRestService } from '../services/api/vas-rest';

export class ApiFacade {

    constructor(protected api: VASRestService) {

    }

    get token(): string {
        return this.api.token;
    }

    r(route: string): string {
        return this.api.r(route);
    }

    createRequest(
        authenticated: boolean,
        route?: string,
        method: string | RequestMethod = RequestMethod.Get,
        headers = {},
        query = {}
    ): RestRequest {
        return this.api.createRequest(
            authenticated,
            route,
            method,
            headers,
            query
        );
    }

    get(route: string, entity: string): Observable<INormalisedResult> {
        return this.api.get(route, entity);
    }

    simpleGet(route: string, options?: ApiRequestOptions): Observable<Response> {
        return this.api.simpleGet(route, options);
    }

    postAccountObject(entity: string, accountId: string, data: object): Observable<Response> {
        return this.api.postAccountObject(entity, accountId, data);
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/api-facade.ts